module.exports = __webpack_public_path__ + "img/oran_12kl.35cf807e.jpg";